import styled from "styled-components";

export const LayoutContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  max-width: 100vw;
`;

export const ContentContainer = styled.main`
  flex: 1;
  display: flex;
  flex-direction: column;
`;
